import { type Plan, PLANS } from "./plans";

export const SEO_ORIGIN = "https://apply-edge.com";
export const ORGANIZATION_ID = `${SEO_ORIGIN}/#organization`;

export const buildOrganizationJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "Apply Edge",
  url: SEO_ORIGIN,
  logo: `${SEO_ORIGIN}/logo/light.svg`,
  sameAs: [
    "https://www.linkedin.com/company/apply-edge",
    "https://chromewebstore.google.com/detail/alhkckkgmbngogjjgjmkbhpdbikgkbjc",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    email: "info@apply-edge.com",
    contactType: "customer support",
  },
});

export const buildWebsiteJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Apply Edge",
  url: SEO_ORIGIN,
  inLanguage: "en-US",
});

export const buildSoftwareApplicationJsonLd = (path: string) => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Apply Edge",
  url: `${SEO_ORIGIN}${path}`,
  applicationCategory: "BusinessApplication",
  applicationSubCategory: "JobSearch",
  operatingSystem: "Web",
  publisher: { "@id": ORGANIZATION_ID },
  offers: (["FREE", "PRO", "ULTIMATE"] as const).flatMap((tier) => {
    const plan: Plan = PLANS[tier];
    const cycles =
      tier === "FREE" ? (["monthly"] as const) : (["weekly", "monthly", "yearly"] as const);
    return cycles.flatMap((cycle) => {
      const price = plan.price[cycle];
      if (price === undefined) return [];
      return [
        {
          "@type": "Offer",
          name: `${plan.name} ${cycle}`,
          price,
          priceCurrency: "USD",
          category: tier === "FREE" ? "free" : "subscription",
          url: `${SEO_ORIGIN}/pricing`,
          availability: "https://schema.org/InStock",
          seller: { "@id": ORGANIZATION_ID },
          priceSpecification: {
            "@type": "UnitPriceSpecification",
            price,
            priceCurrency: "USD",
            billingDuration: 1,
            billingIncrement: 1,
            unitCode: { weekly: "WEE", monthly: "MON", yearly: "ANN" }[cycle],
          },
        },
      ];
    });
  }),
});
